export default function extractErrors(responseData) {
  const errorKeys = Object.keys(responseData);
  const errors = [];
  errorKeys.forEach(key => errors.push(responseData[key]));
  return errors;
}
